const ZERONE_COLORS = {
    primary: '#FF5522',
    secondary: '#136A97',
    tertiary: '#89615d',
    quaternary: '#228866',
    background: '#f5f5f5',
    textPrimary: '#282828',
    textLight: '#707070',
    border: '#5C96B51A',
    gridLines: '#D8EAF2'
}

export default ZERONE_COLORS;